// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kAEa","largestCol":"styles_largestCol__239pK","smallestCol":"styles_smallestCol__fbEIF"};